import * as React from 'react';
import { useRecoilValue } from 'recoil';
import PermissionsService, {
  PERMISSION_WAYPOINT_CUSTOMER,
  PERMISSION_WAYPOINT_PRIVATE,
} from '../../../Services/PermissionsService';
import DrawedWaypoint from '../Waypoints/DrawedWaypoint';
import DrawWaypoint from '../Waypoints/DrawWaypoint';
import EditedDrawedWaypoint from '../Waypoints/EditDrawedWaypoint';
import { selectedCustomersAtom } from '../../../store/recoil/customers';

interface IWaypointsLayerProps {
  googleMap: google.maps.Map | undefined;
}

export default function WaypointsLayer(props: IWaypointsLayerProps) {
  const selectedCustomers = useRecoilValue<number[]>(selectedCustomersAtom);
  return (
    <div className="w-map w-map--wrapper">
      {props.googleMap &&
        (PermissionsService.hasAccess(
          PERMISSION_WAYPOINT_CUSTOMER,
          ['create', 'update'],
          selectedCustomers
        ) ||
          PermissionsService.hasAccess(
            PERMISSION_WAYPOINT_PRIVATE,
            ['create', 'update'],
            selectedCustomers
          )) && <DrawWaypoint map={props.googleMap} />}
      {props.googleMap &&
        (PermissionsService.hasAccess(
          PERMISSION_WAYPOINT_CUSTOMER,
          ['create', 'update', 'read'],
          selectedCustomers
        ) ||
          PermissionsService.hasAccess(
            PERMISSION_WAYPOINT_PRIVATE,
            ['create', 'update', 'read'],
            selectedCustomers
          )) && <DrawedWaypoint map={props.googleMap} />}
      {props.googleMap &&
        (PermissionsService.hasAccess(
          PERMISSION_WAYPOINT_CUSTOMER,
          ['create', 'update'],
          selectedCustomers
        ) ||
          PermissionsService.hasAccess(
            PERMISSION_WAYPOINT_PRIVATE,
            ['create', 'update'],
            selectedCustomers
          )) && <EditedDrawedWaypoint map={props.googleMap} />}
      {/* {props.googleMap && <WaypointsContainer />} */}
    </div>
  );
}
